module.exports = {
  background: "#FAFAFA",
  blackGrad: "linear-gradient(to right top, #000000, #191919, #2c2c2c, #3f3f3f, #545454)",
  pinkGrad: "linear-gradient(to left, #fdd9d9, #fec3c3, #feaead, #fc9897, #f98181)",
  pink: "#FDA2A2",
  pinkDark: "#FA7D7D",
  white: "white",
  dark: "#333",
  grey: "#333",
  lightGrey: "#bbbbbb",
  superLightGrey: "#dedede"
};



// WEBPACK FOOTER //
// ./src/styles/colors.js